module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABNElEQVRIie3VIUtDURiH8d8uG7omwuIsokEGY9fqqkGDVpNfwE+g2W7wA7i0PASrsGEwODQPy2ZbMokIarjnolMRdu/i/u2cw3mec943vIVGdyhkHcfYQUW2jHGF036zOoAoHOzhHocB/pxRUAmMh7g32ksF62ijjHfsYglbeM0oKqMd90ZrkaQs5XBwJ/ki3OA6oyCVnESSmqdZlbweFrGRQwA7RZMNXcYtLrGNlZyCSqHRHX7khPyb4o/1I85zMo8kpf5T8ISzaWj9ZnViHfdG+98F0c8Ls85cMBfMBb8FpRkwJxiRZMyl2UQtKznujWqBkWZcaHSHF5Ixl+ZVMnjepuSXAnzh216r0OgO1/Dga6rNKi+oRxjgIGzMEn7Qb1YHaZM7qKNlsifTZhwY9X6z2oFPs7w+cs4tO+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/recordInformation/10.png
// module id = 575
// module chunks = 2